<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col lg="12">
        <PageTitle></PageTitle>
        <b-card v-if="!showConfirm">
          <b-row>
            <b-col sm="6">
              <b-form-group>
                <label for="procedures">{{ $tc('title.procedures', 1) }}
                  <required-field/>
                </label>
                <v-select id="procedures" v-model="procedureModel.procedures" :options="procedures" multiple label="id"
                          :getOptionLabel="getParsedProcedure"></v-select>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col sm="6">
              <b-form-group>
                <label for="models">{{ $tc('title.models', 0) }}
                  <required-field/>
                </label>
                <v-select id="models" v-model="procedureModel.models" :options="models" multiple
                          :getOptionLabel="getParsedModels"></v-select>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col sm="12">
              <button class="btn btn-success float-right padder" type="button" @click="handleShowConfirm"
                      :disabled='isDisabled'>
                {{ $t('actions.continue') }}
              </button>
              <router-link class="btn btn-primary float-right" role="button" :to="{name: 'procedureModelRoute'}" push>
                {{ $t('actions.abort') }}
              </router-link>
            </b-col>
          </b-row>
        </b-card>
        <b-card v-if="showConfirm">
          <div class="bd-example">
            <dl class="row">
              <div class="col-6">
                <dt>{{ $tc('title.procedures', 0) }}</dt>
                <div v-for="procedure in procedureModel.procedures" :key="procedure.id">
                  <div v-for="model in procedureModel.models" :key="model.id">
                    <dd class="col-sm-9">{{ procedure.label }}</dd>
                  </div>
                </div>
              </div>
              <div class="col-6">
                <dt>{{ $tc('title.models', 1) }}</dt>
                <div v-for="procedure in procedureModel.procedures" :key="procedure.id">
                  <div v-for="model in procedureModel.models" :key="model.id">
                    <dd class="col-sm-9">{{ model.label + ' ' + model.description }}</dd>
                  </div>
                </div>
              </div>
            </dl>
          </div>
          <b-row>
            <b-col sm="12">
              <button class="btn btn-success float-right padder" type="button" @click="handleCreate">
                {{ $t('actions.save') }}
              </button>
              <router-link class="btn btn-primary float-right" role="button" :to="{name: 'procedureModelRoute'}" push>
                {{ $t('actions.abort') }}
              </router-link>
            </b-col>
          </b-row>
        </b-card>
        <!-- Modal Component -->
        <b-modal title="Conferma Modifica Associazione Prestazione - Modello" class="modal-danger" v-model="updateModal"
                 @ok="updateProcedureModel"
                 size="lg"
                 ok-variant="danger">
          {{ $t('procedureModel.message.confirmUpdate.confirm') }}
          <div class="my-2">
            <h4 class="my-0">Prestazione: {{ getProcedureModelLabel }}</h4>
            <h4 class="my-0">Modello: {{ procedureModel.modelCode }}</h4>
          </div>
          {{ $t('procedureModel.message.confirmUpdate.warning') }}
        </b-modal>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import miniToastr from 'mini-toastr' //ES6
import PageTitle from '@/components/PageTitle'
import RequiredField from "../../components/RequiredField";
import vSelect from 'vue-select'
import ModelService from "@/services/ModelService";
import ProcedureModelService from "@/services/ProcedureModelService";
import ProcedureService from "@/services/ProcedureService";

const modelService = ModelService.build();
const procedureService = ProcedureService.build();
const procedureModelService = ProcedureModelService.build();

export default {
  name: 'ProcedureModelNew',
  inheritAttrs: false,
  components: {
    RequiredField,
    PageTitle,
    vSelect,
  },
  data() {
    return {
      procedureModel: {},
      procedures: [],
      models: [],
      errors: [],
      loading: false,
      updateModal: false,
      showConfirm: false
    }
  },
  created() {
    miniToastr.init(); // config can be passed here miniToastr.init(config)
    miniToastr.setIcon('error', 'i', {'class': 'fas fa-exclamation-triangle'});
    this.getModels();
    this.getProcedures();
  },
  computed: {
    getProcedureModelLabel() {
      return this.procedureModel.procedureCode + ' ' + this.procedureModel.procedureLabel
    },
    isDisabled: function () {
      console.log(this.procedureModel)
      return !(this.procedureModel.procedures && this.procedureModel.models)
    }
  },
  methods: {
    async updateProcedureModel() {
      try {
        await procedureModelService.update(this.procedureModel)
        this.$router.push({name: 'procedureModelShowRoute', params: {id: this.id}})
        miniToastr.info("Associazione Prestazione - Modello aggiornata con successo");
      } catch (exception) {
        this.errors = exception.errors
        exception.errors.forEach(function (element) {
          miniToastr.error(element.message);
        });
      }
    },
    async getModels() {
      this.models = (await modelService.search({max: -1})).data;
    },
    async getProcedures() {
      this.procedures = (await procedureService.search({max: -1})).data;
    },
    async handleConfirmUpdate() {
      this.updateModal = true;
    },
    handleShowConfirm() {
      this.showConfirm = true;
    },
    getParsedModels(model) {
      return model.code + ' ' + model.description
    },
    getParsedProcedure(procedure) {
      return procedure.label + " " + procedure.source.label
    },
    async handleCreate() {
      try {
        // TODO Si potrebbe fare di meglio evitando di ciclare 2 volte ma recuperando già i dati come vogliamo dai v-model
        const procedureCodeList = this.procedureModel.procedures.map((item) => {
          let properties = {}
          properties["procedureCode"] = item['code'];
          properties["sourceCode"] = item['source']['code'];
          return properties
        });
        const modelCodeList = this.procedureModel.models.map((item) => item['code']);

        await procedureModelService.create({procedureCodeList, modelCodeList});

        this.$router.push({name: `procedureModelListRoute`})
      } catch (exception) {
        this.errors = exception;
        miniToastr.error(exception.message);
      }
    }
  }
}
</script>

